
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import { SERVERURL } from "../ServerUrl";
import ForgotPassword from '../Components/ForgotPassword/ForgotPassword';
import ResetPassword from '../Components/ForgotPassword/Reset';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const navigate=useNavigate();
  const [resetToken, setResetToken] = useState('');
  // Shown inside the card instead of a popup.
  const [feedback, setFeedback] = useState(null);

  const handleForgotPasswordSubmit = async (email) => {
    setFeedback(null);

    try {
      console.log("came forgot password",email);
      const response = await axios.post(`${SERVERURL}/api/v1/forgotPassword`, { email });
      if (response.data.message === 'Email sent') {
        setResetToken(true);
        setFeedback({ type: 'success', text: 'Reset link sent to your mail.' });
      }
      else
      {
        setFeedback({ type: 'error', text: response.data.message });
      }
    } catch (error) {
      console.error('Error:', error);
      setFeedback({
        type: 'error',
        text: error.response?.data?.message || 'Something went wrong. Try again.',
      });
    }

  };

  return (
    <>
    <Header minimal/>
    {/* {!resetToken && (
        <ResetPassword token={resetToken} onSubmit={handleResetPasswordSubmit} />
      ) : ( */}
        <ForgotPassword onSubmit={handleForgotPasswordSubmit} feedback={feedback} />
      {/* )} */}
    <Footer/>
    </>
  )
}

export default ForgotPasswordPage
